import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  canonicalUrl?: string;
  type?: 'website' | 'article';
}

export const SEO: React.FC<SEOProps> = ({ 
  title, 
  description, 
  image, 
  canonicalUrl,
  type = 'website'
}) => {
  const location = useLocation();
  
  // Default Site Metadata
  const defaultTitle = "Online Consultation with Verified Astrologers, Lawyers & Doctors";
  const defaultDesc = "TrueAdviso: talk to verified astrologers & lawyers by the minute, or book doctor consultations by session — live video, audio & chat, trusted experts anytime.";
  const defaultImage = "https://trueadviso.com/advisofav-icon.png";

  // 🟢 CASE-INSENSITIVE TITLE FORMATTING (Prevents duplicate "| TrueAdviso" suffixes)
  const fullTitle = title 
    ? (title.toLowerCase().includes("trueadviso") ? title : `${title} | TrueAdviso`)
    : `${defaultTitle} | TrueAdviso`;

  const metaDescription = description || defaultDesc;
  const metaImage = image || defaultImage;
  const currentCanonical = canonicalUrl || `https://trueadviso.com${location.pathname}`;

  return (
    <Helmet>
      {/* 🟢 Browser Tab Title & Search Meta Description */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />

      {/* 🟢 Dynamic Canonical Link */}
      <link rel="canonical" href={currentCanonical} />

      {/* 🟢 OpenGraph Meta Tags (Facebook, WhatsApp, LinkedIn) */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={currentCanonical} />
      <meta property="og:image" content={metaImage} />

      {/* 🟢 Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
    </Helmet>
  );
};